import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabPanelComponent } from './tab-panel/tab-panel.component';
// import {InsparkComponentsModule} from '@inspark/inspark-components';
import {TranslateModule} from '@ngx-translate/core';
import {InsparkUIModule} from "../../../../src/app/inspark.module";



@NgModule({
  declarations: [TabPanelComponent],
  imports: [
    CommonModule,
    TranslateModule,
    InsparkUIModule
  ],
  exports: [TabPanelComponent]
})
export class InsparkTabPanelModule { }
